function PicsartLogo() {
  return (
    <img
      style={{ display: 'block', verticalAlign: 'top' }}
      src="https://pastatic.picsart.com/cms-pastatic/1a06f6d1-a44e-4a8c-af24-6ef22b70a2d9.svg"
      width={24}
      height={24}
    />
  );
}
export default PicsartLogo;
